<template>
	<div class="floating" v-if="isShow">
		<div class="top">
			<img class="jiqiren" src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xiaodongxiao01.gif"
				alt="" />
			<p class="phone">全国热线电话</p>
			<!-- <p class="tel">400-039-7699</p> -->
			<p class="tel">15617622505</p>
			<!-- <button @click="toConsult">在线咨询</button> -->
			<a href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn" target="_blank">在线咨询</a>
		</div>
		<div class="bottom" @click="toTop" v-if="showBtn">
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/huiding.png" alt="" />
			<p>回到顶部</p>
		</div>
		<img class="xxx" @click="close" src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xxx.png"
			alt="" />
	</div>
</template>

<script>
	export default {
		name: "Floating",
		data() {
			return {
				isShow: true,
				showBtn: false,
			};
		},
		mounted() {
			window.addEventListener("scroll", this.showbtn, true);
		},
		methods: {
			toTop() {
				var timer = setInterval(function() {
					let osTop =
						document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop / 5);
					document.documentElement.scrollTop = document.body.scrollTop =
						osTop + ispeed;
					this.isTop = true;
					if (osTop === 0) {
						clearInterval(timer);
					}
				}, 30);
			},
			showbtn() {
				let that = this;
				let scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				that.scrollTop = scrollTop;
				if (scrollTop > 800) {
					this.showBtn = true;
				} else {
					this.showBtn = false;
				}
			},
			close() {
				this.isShow = false;
			},
			// toConsult() {
			// 	window.open(
			// 		"https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
			// 		"_blank"
			// 	);
			// },
		},
	};
</script>

<style lang="less" scoped>
	.floating {
		position: fixed;
		height: 340px;
		width: 140px;
		bottom: 20px;
		right: 20px;
		z-index: 999;

		.xxx {
			display: block;
			width: 16px;
			height: 16px;
			position: absolute;
			top: 5px;
			right: -8px;
		}

		.xxx:hover {
			cursor: pointer;
		}

		.top {
			height: 240px;
			width: 100%;
			border-radius: 70px 70px 6px 6px;
			background-color: #e71115;
			overflow: hidden;
			box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.2);

			.jiqiren {
				display: block;
				margin: 0 auto;
				margin-top: 28px;
				width: 88px;
				height: 88px;
				border-radius: 50%;
			}

			.phone {
				width: 140px;
				text-align: center;
				margin: 0 auto;
				height: 30px;
				font-size: 12px;
				font-weight: 500;
				color: #ffffff;
				line-height: 30px;
			}

			.tel {
				width: 140px;
				text-align: center;
				margin: 0 auto;
				height: 20px;
				font-size: 16px;
				font-weight: 500;
				color: #ffffff;
				line-height: 20px;
			}

			a {
				display: block;
				width: 110px;
				height: 36px;
				border-radius: 6px;
				background-color: #ffffff;
				color: #e71115;
				line-height: 36px;
				text-align: center;
				margin: 0 auto;
				margin-top: 20px;
				font-weight: 600;
				font-size: 18px;
				text-align: center;
				line-height: 36px;
			}
		}

		.bottom {
			display: flex;
			justify-content: space-around;
			align-items: center;
			width: 140px;
			height: 42px;
			background-color: #e71115;
			margin-top: 20px;
			border-radius: 6px;
			box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.2);

			img {
				display: block;
				width: 24px;
				height: 24px;
				margin-left: 6px;
			}

			p {
				width: 80px;
				font-weight: 500;
				font-size: 16px;
				color: #ffffff;
			}
		}

		.bottom:hover {
			cursor: pointer;
		}
	}
</style>